export const toIntegerCurrency = (num: number): number =>
  Math.round((num + Number.EPSILON) * 100);

export const toWholeCurrency = (num: number): number => {
  if (num == null || num === 0 || Number.isNaN(num)) {
    return 0;
  }

  return num / 100;
};

/**
 * Take a number and round it to two decimal places.
 * @param  {number} num Original unrounded number.
 * @return {number}     Rounded number.
 */
export const roundToTwoDecimals = (num: number): number =>
  Math.round((num + Number.EPSILON) * 100) / 100;
